import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Flex, TabNav, Heading, Container } from '@radix-ui/themes';
import { useEffect } from 'react';

export default function SettingsPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to integrations by default
  useEffect(() => {
    if (
      location.pathname === '/settings' ||
      location.pathname === '/settings/'
    ) {
      navigate('/settings/integrations', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Container size="4" p="2">
      <Flex direction="column" gap="3">
        <Heading size="6">Settings</Heading>

        <TabNav.Root>
          <TabNav.Link
            href="/settings/integrations"
            active={location.pathname.startsWith('/settings/integrations')}
          >
            Integrations
          </TabNav.Link>
          <TabNav.Link
            href="/settings/api-keys"
            active={location.pathname === '/settings/api-keys'}
          >
            API Keys
          </TabNav.Link>
          <TabNav.Link
            href="/settings/profile"
            active={location.pathname === '/settings/profile'}
          >
            Profile
          </TabNav.Link>
        </TabNav.Root>

        <Outlet />
      </Flex>
    </Container>
  );
}
